import {
  DEFAULT_PROPERTIES_LIST_VIEW_MODE,
  PROPERTIES_LIST_VIEW_MODE,
  type PropertiesListViewMode,
} from '../constants/PropertiesListConstants';
import QueryConstants from '../constants/QueryConstants';
import { ROUTES } from '../constants/urls';
import { replaceRouterQueryParams } from './routerQueryUtils';

import type { NextRouter } from 'next/router';

export type PropertiesListFilterState = {
  searchText: string;
  includeArchived: boolean;
};

export const defaultPropertiesListFilters: PropertiesListFilterState = {
  searchText: '',
  includeArchived: false,
};

const isValidViewMode = (value: string): value is PropertiesListViewMode =>
  Object.values(PROPERTIES_LIST_VIEW_MODE).includes(value as PropertiesListViewMode);

export const initializePropertiesListFiltersFromRouter = (
  query: NextRouter['query'],
  defaults: PropertiesListFilterState = defaultPropertiesListFilters,
): PropertiesListFilterState => ({
  ...defaults,
  searchText: (query[QueryConstants.SEARCH_TEXT] as string) || defaults.searchText,
  includeArchived: query[QueryConstants.ARCHIVED] === 'true' || defaults.includeArchived,
});

export const initializeViewModeFromRouter = (
  query: NextRouter['query'],
  defaultViewMode: PropertiesListViewMode = DEFAULT_PROPERTIES_LIST_VIEW_MODE,
): PropertiesListViewMode =>
  isValidViewMode(query[QueryConstants.VIEW_MODE] as string)
    ? (query[QueryConstants.VIEW_MODE] as PropertiesListViewMode)
    : defaultViewMode;

export const initializePropertiesListPageStateFromQuery = (query: NextRouter['query']) => ({
  filters: initializePropertiesListFiltersFromRouter(query),
  viewMode: initializeViewModeFromRouter(query),
});

export const updatePropertiesListRouterWithFilters = (
  router: NextRouter,
  filters: PropertiesListFilterState,
  viewMode: PropertiesListViewMode,
) =>
  replaceRouterQueryParams(router, ROUTES.PROPERTIES, {
    [QueryConstants.SEARCH_TEXT]: filters.searchText.trim() || undefined,
    [QueryConstants.ARCHIVED]: filters.includeArchived ? 'true' : undefined,
    [QueryConstants.VIEW_MODE]: viewMode !== DEFAULT_PROPERTIES_LIST_VIEW_MODE ? viewMode : undefined,
    [QueryConstants.EXPANDED_GROUP]: undefined,
  });
